// @flow
import React, { Component, ComponentType } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import dateFormat from "dateformat";

import SpinnerIcon from "@atlaskit/spinner";
import GoogleMapsLoader from "google-maps";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from "react-places-autocomplete";

import { isCD } from "../rest/utils/envDetection";

import { event } from "../utils/events";

import { Title, Text, Form, Buttons, SpinnerWrapper, SearchResults, SearchResult } from "./styled";

type Props = {|
    open: boolean,
    onHide: Function,
    Dialog: ComponentType<any>,
    onFetchStops: Function,
    onFetchUserInfo: Function,
    submitState: Object
|};

class PlotMap extends Component<Props> {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    componentDidMount() {
        if (isCD) {
            console.log("Not Loading GoogleMaps on CD");
            return;
        }

        console.log("Loading GoogleMaps");
        GoogleMapsLoader.KEY =
            process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyBplMsQdHSqaou9p3utfAfsmB2OMzdwnmc";
        GoogleMapsLoader.VERSION = "weekly";
        GoogleMapsLoader.LIBRARIES = ["places"];
        GoogleMapsLoader.load(google => {
            console.log("Loaded GoogleMaps");
            this.setState({ google });
        });
    }

    onSuggestionSelected(selectionText, place, latLng) {
        this.setState({
            address: selectionText,
            submitState: null,
            selected: { selectionText, place, latLng }
        });
    }

    onClose = () => {
        this.props.onHide();
        this.setState(this.initialState());
    };

    initialState = () => {
        const today = dateFormat(new Date(), "yyyy-mm-dd");
        const state = {
            submitState: this.props.submitState,
            date: today,
            drawLine: true,
            address: "",
            selected: null
        };

        return state;
    };

    handleAddressChange = address => {
        this.setState({ address, selected: null });
    };

    handleDateChange = () => e => {
        this.setState({
            date: e.target.value
        });
    };

    handleToggle = () => e => {
        this.setState({ drawLine: e.target.checked });
    };

    handleSelect = async selectionText => {
        // Set the textbox text but don't set the selection until we have GPS
        this.setState({ address: selectionText, submitState: "loadinggps" });
        const results = await geocodeByAddress(selectionText);
        const place = results[0];
        const latLng = await getLatLng(place);
        this.onSuggestionSelected(selectionText, place, latLng);
    };

    saveStop = async () => {
        const { selected } = this.state;
        const { latLng, place, selectionText } = selected;
        this.setState({ submitState: "submitting" });
        event({
            category: `Submitting data`,
            action: "Location"
        });

        const countryComponent = place.address_components.find(p => p.types.includes("country"));
        const coutryName = countryComponent.long_name;
        const countryCode = countryComponent.short_name;
        const locationName = selectionText.replace(`, ${coutryName}`, "");
        const data = new URLSearchParams();
        data.append("action", "searchloc");
        data.append("submit", "1");
        data.append("draw_line", this.state.drawLine ? 1 : 0);
        data.append("geonameId", 1);
        data.append("date", this.state.date);
        data.append("name1", locationName);
        data.append("lat1", latLng.lat);
        data.append("long1", latLng.lng);
        data.append("countrycode1", countryCode);

        console.log(`saving ${locationName} date: ${this.state.date} cc: ${countryCode}`, selected);

        await fetch("https://www.getjealous.com/admin.php", {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            credentials: "include", // include, same-origin, *omit
            body: data // body data type must match "Content-Type" header
        });

        this.props.onFetchStops();
        this.props.onFetchUserInfo();

        this.setState({ submitState: "submitted" });
        this.onClose();
    };

    render() {
        const { Dialog, open } = this.props;
        const { submitState } = this.state;

        return this.state.google === undefined ? (
            <div />
        ) : (
            <div>
                <Dialog open={open} showCloseButton={false} onHide={this.onClose}>
                    <Form>
                        <Title>Update Location</Title>
                        <Text>Show everyone where you have been and where you are going.</Text>
                        <TextField
                            label="Date"
                            onChange={this.handleDateChange()}
                            defaultValue={this.state.date}
                            type="date"
                            id="dateField"
                        />
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={this.state.drawLine}
                                    color="primary"
                                    onChange={this.handleToggle()}
                                    value="checkedA"
                                />
                            }
                            label="Draw line on map"
                        />
                        <PlacesAutocomplete
                            value={this.state.address}
                            onChange={this.handleAddressChange}
                            onSelect={this.handleSelect}
                        >
                            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                <div>
                                    <TextField
                                        fullWidth
                                        {...getInputProps({
                                            label: "Location",
                                            className: "location-search-input"
                                        })}
                                    />
                                    <SearchResults className="autocomplete-dropdown-container">
                                        {loading && <SearchResult>Loading...</SearchResult>}
                                        {suggestions.map(suggestion => {
                                            const className = suggestion.active
                                                ? "suggestion-item--active"
                                                : "suggestion-item";
                                            // inline style for demonstration purpose
                                            const style = suggestion.active
                                                ? { backgroundColor: "#fafafa" }
                                                : { backgroundColor: "#ffffff" };
                                            return (
                                                <SearchResult
                                                    {...getSuggestionItemProps(suggestion, {
                                                        className,
                                                        style
                                                    })}
                                                >
                                                    <span>{suggestion.description}</span>
                                                </SearchResult>
                                            );
                                        })}
                                    </SearchResults>
                                </div>
                            )}
                        </PlacesAutocomplete>
                        <Buttons>
                            <Button onClick={this.onClose} variant="contained" color="secondary">
                                Close
                            </Button>
                            {submitState === null &&
                                this.state.selected !== null && (
                                    <Button
                                        onClick={this.saveStop}
                                        variant="contained"
                                        color="primary"
                                    >
                                        Save Location
                                    </Button>
                                )}
                            {(submitState === "submitting" ||
                                submitState === "submitted" ||
                                submitState === "loadinggps") && (
                                <SpinnerWrapper>
                                    <SpinnerIcon
                                        size="medium"
                                        isCompleting={submitState === "submitted"}
                                        onComplete={this.onClose}
                                        style={{ backgroundColor: "#000" }}
                                    />
                                </SpinnerWrapper>
                            )}
                        </Buttons>
                    </Form>
                </Dialog>
            </div>
        );
    }
}

export default PlotMap;



// WEBPACK FOOTER //
// ./src/plot-map-dialog/view.js